import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Flag, Icon, Popup, Header, Dropdown } from 'semantic-ui-react';
import cn from 'classnames';

import { Accounts, CustomAccount, AiToolset } from 'actions';
import { colors } from 'utils/colors';
import { notWealthica, getTickerSearchResult } from 'utils/helpers';
import { saveModalCharLimits } from '../../../utils/constants';
import {
  Modal,
  Message,
  Table,
  Button,
  Segment,
  Selection,
  SearchTicker,
} from '../../../components';
import { Quantity, CashAmount, ConfirmModal } from './components';
import {
  translateAssetClass,
  translateTableHeadings,
  translateText,
  formatNum,
} from '../../../utils/helpers';

@withRouter
@connect((state) => ({
  customAcc: state.CustomAccount,
  account: state.CustomAccount.account,
  partnerName: state.Storage['partner-name'],
  french: state.Storage.language === 'fr',
  user_region: state.Storage.user_region,
  toggle_region: state.Storage.toggle_region || 'CA',
}))
export default class BuildCustomAccount extends Component {
  state = {
    isOpen: false,
    conflictAccounts: null,
    resolveGicConflict: false,
    gicError: false,
    isQuantity: true,
    errors: {},
    institution: '',
    name: '',
    gic_rate: '',
    gic_quantity: '',
    advisor_fee: '',
  };

  componentWillMount() {
    const { dispatch, match, customAcc } = this.props;
    const { id } = match.params;

    if (
      Number(id) &&
      !Object.keys(customAcc.holdings).length &&
      !customAcc.gic_quantity &&
      !customAcc.gic_rate
    ) {
      return dispatch(CustomAccount.fetchId(id));
    }

    return false;
  }

  componentDidMount() {
    const { user_region } = this.props;
    if (user_region === 'US') {
      this.setState({ currency: 'USD' });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const { match } = this.props;

    if (
      match.params.id === 'new' &&
      nextProps.account &&
      Number(nextProps.account.id)
    ) {
      return history.push(`/accounts/custom/${nextProps.account.id}`);
    }

    return false;
  }

  // componentDidUpdate(prevProps) {}

  componentWillUnmount() {
    this.props.dispatch(CustomAccount.clearCustomAccount());
  }

  getPriceFlag = (holding) => {
    const currency = {
      CAD: 'ca',
      USD: 'us',
    };

    // if security_detail does not exist, use yodlee currency for flag
    return holding.security_detail
      ? currency[holding.security_detail.default_currency]
      : currency[holding.default_currency];
  };

  getFlag = (currency) => {
    const options = {
      CAD: 'ca',
      USD: 'us',
    };

    return options[currency];
  };

  getPrice = (holding, isMatched) => {
    if (!holding) return 'N/A';
    if (holding.security_detail) {
      return this.round(
        holding.security_detail.unadjusted_closing_price[
          holding.security_detail.default_currency
        ]
      );
    }
    if (isMatched === 'unmatched') {
      return this.round(holding.unadjusted_closing_price[holding.currency]);
    }
    return 'N/A';
  };

  getMarketValue = (holding) => {
    if (!holding.market_value && !holding.quantity) {
      return 0;
    }

    // use our generated price if exists, else use yodlee price
    const price = holding.security_detail
      ? holding.security_detail.unadjusted_closing_price.CAD
      : holding.unadjusted_closing_price.CAD || 0;

    // use yodlee market_value if exists, else use our market_value
    const mktValue = holding.market_value || price * holding.quantity;

    return mktValue;
  };

  getSearchParams = () => {
    const { account, user_region } = this.props;
    const types = [];
    const currency =
      user_region === 'CA' && account.currency === 'USD' ? 'USD' : '';
    const region = currency === 'USD' ? 'US' : user_region;
    return { region, types };
  };

  setResolveGicConflict = () =>
    this.setState({ resolveGicConflict: true }, this.saveBulk);

  round = (num) => Math.round(num * 100) / 100;

  createAccount = () => {
    const { name, institution, currency } = this.state;
    const { dispatch } = this.props;
    if (this.createAccountButtonDisabled()) return false;

    dispatch(CustomAccount.updateCash(0));

    return dispatch(
      CustomAccount.createAccount({
        name,
        institution,
        currency,
        label: name,
        user_institution: institution,
      })
    );
  };

  saveBulk = () => {
    const { dispatch, customAcc, account, history } = this.props;
    const { advisorFee, gic_quantity, gic_rate, gic_ticker, gic_name } =
      customAcc;
    const { resolveGicConflict, isQuantity } = this.state;
    const gicFormat = /^GIC\d*:MKT$/;
    const getParams = () =>
      Object.keys(customAcc.holdings).reduce(
        (acc, key) => {
          if (!gicFormat.test(key)) {
            const {
              quantity,
              book_value,
              marketValue,
              ticker,
              security_detail,
            } = customAcc.holdings[key];

            // if unmatched holding with ticker
            if (!security_detail && ticker) {
              acc.tickers += !acc.tickers.length ? `${ticker}` : `,${ticker}`;
              acc.quantities += !acc.quantities.length
                ? `${quantity}`
                : `,${quantity}`;
              acc.book_values += !acc.book_values.length
                ? `${book_value || 0}`
                : `,${book_value || 0}`;
            } else if (
              security_detail &&
              security_detail.unadjusted_closing_price.CAD
            ) {
              let newMarketVal = marketValue;

              if (
                // if account currency is in CAD and holding price is USD,
                // convert market value to USD in order to calculate correct quantity
                // (we now assume that users are entering market value in the currency of the account)
                customAcc.holdings[key].security_detail.default_currency ===
                  'USD' &&
                customAcc.account.currency === 'CAD'
              ) {
                newMarketVal /= localStorage.getItem('pwpa-exchange-rate');
              }
              const price = this.getPrice(customAcc.holdings[key]);
              const newQuantity = isQuantity
                ? quantity
                : this.round(newMarketVal / price);
              const matchedTicker =
                customAcc.holdings[key].security_detail.ticker;
              acc.tickers += !acc.tickers.length
                ? `${matchedTicker}`
                : `,${matchedTicker}`;
              acc.quantities += !acc.quantities.length
                ? `${newQuantity}`
                : `,${newQuantity}`;
              acc.book_values += !acc.book_values.length
                ? `${book_value || 0}`
                : `,${book_value || 0}`;
            }
          }

          return acc;
        },
        { tickers: '', quantities: '', book_values: '' }
      );
    const params = {
      account_id: account.id,
      cash_amount: customAcc.cash,
      ...(gic_quantity &&
        gic_rate &&
        gic_ticker && {
          gics: [
            {
              gic_quantity: gic_quantity.toString(),
              gic_rate: parseFloat((gic_rate / 100).toFixed(4)),
              gic_ticker,
              gic_name,
            },
          ],
        }),
      ...(resolveGicConflict && { resolve_gic_conflict: resolveGicConflict }),
      ...getParams(),
    };

    return dispatch(CustomAccount.saveBulk(params)).then((response) => {
      this.setState({ resolveGicConflict: false });

      if (response && response.type === 'CUSTOMACCOUNT_HOLDING_FAIL') {
        if (response.msg.split(' ')[0] === 'gic_rate') {
          const conflictAccounts = response.msg
            .substring(0, response.msg.length - 1)
            .split('[')[1]
            .split(', ');

          return this.setState({ isOpen: 'confirm', conflictAccounts });
        } else if (response.msg.split(' ')[0] === 'currency') {
          return this.setState({ gicError: 'Ticker' });
        } else if (response.msg.split(' ')[0] === 'Unique') {
          return this.setState({ gicError: 'Unique' });
        }
      }
      dispatch(Accounts.edit(account.id, { advisor_fee: advisorFee || 0 }));

      return history.push(`/accounts/${account.id}`);
    });
  };

  saveOnlyCash = () => {
    const { dispatch, customAcc, account, history } = this.props;

    dispatch(
      CustomAccount.saveBulk({
        account_id: account.id,
        cash_amount: customAcc.cash,
        quantities: '',
        tickers: '',
        book_values: '',
      })
    );

    return dispatch(
      Accounts.edit(account.id, {
        cash: customAcc.cash,
        balance: customAcc.cash,
      })
    ).then(() =>
      dispatch(Accounts.fetchAll()).then(() =>
        history.push(`/accounts/${account.id}`)
      )
    );
  };

  remove = (ticker) => {
    const { dispatch } = this.props;

    return dispatch(CustomAccount.remove(ticker));
  };

  removeAll = () => this.props.dispatch(CustomAccount.removeAll());

  isDisabled = () => {
    const { customAcc } = this.props;
    const { gic_ticker, gic_quantity, gic_rate } = customAcc;
    const { isQuantity } = this.state;
    const gicFormat = /^GIC\d*:MKT$/;
    const hasGic = gic_ticker || gic_quantity || gic_rate;
    const gicComplete =
      gic_ticker &&
      gic_quantity &&
      gic_rate &&
      gic_rate > 0 &&
      gic_quantity > 0;
    const nonGicHoldings = Object.keys(customAcc.holdings).filter(
      (ticker) => !gicFormat.test(ticker)
    );
    const hasNonGicHolding = nonGicHoldings.length;
    const holdingLackQuantity = nonGicHoldings.reduce((acc, ticker) => {
      if (isQuantity && !customAcc.holdings[ticker].quantity) {
        acc = true;
      }

      return acc;
    }, false);
    const holdingLackMarketValue = nonGicHoldings.reduce((acc, ticker) => {
      if (!isQuantity && !customAcc.holdings[ticker].marketValue) {
        acc = true;
      }

      return acc;
    }, false);
    const quantityOrMvComplete =
      !holdingLackQuantity && !holdingLackMarketValue;

    if (hasNonGicHolding && hasGic) {
      return !gicComplete || !quantityOrMvComplete || !(customAcc.cash >= 0);
    }
    if (hasNonGicHolding) {
      return !(customAcc.cash >= 0) || !quantityOrMvComplete;
    }
    if (hasGic) {
      return !gicComplete || !(customAcc.cash >= 0);
    }
    if (hasNonGicHolding) {
      return !quantityOrMvComplete;
    }
    if (hasGic) {
      return !gicComplete;
    }
    return !(customAcc.cash >= 0);
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'institution') {
      if (value.length > saveModalCharLimits[name])
        this.setState({
          errors: {
            ...this.state.errors,
            institution: `Maximum ${saveModalCharLimits[name]} characters`,
          },
        });
      else {
        this.setState({
          errors: {
            ...this.state.errors,
            institution: null,
          },
        });
      }
    }

    if (name === 'name') {
      if (value.length > saveModalCharLimits.accountType)
        this.setState({
          errors: {
            ...this.state.errors,
            accountType: `Maximum ${saveModalCharLimits.accountType} characters`,
          },
        });
      else {
        this.setState({
          errors: {
            ...this.state.errors,
            accountType: null,
          },
        });
      }
    }

    return this.setState({ [name]: value });
  };

  handleGICOrAdvisorFeeChange = (e) => {
    const { dispatch } = this.props;
    const { name, value } = e.target;
    let num = value.replace(/^0+(\d)/, '$1');
    if (num.startsWith('.')) num = `0${num}`;
    if (num.includes('.')) {
      const [whole, decimal] = num.split('.');
      num = `${whole}.${decimal.substring(0, 2)}`;
    }
    this.setState({ [name]: num });
    const limitRegex = /^\d*\.?\d*$/;
    const negative = !limitRegex.test(num);

    if (name === 'gic_ticker') {
      this.setState({ isOpen: false, gicError: false });
    }

    if (name === 'gic_rate') {
      this.setState({ isOpen: false });
    }

    if (negative) {
      if (name === 'gic_quantity' || name === 'gic_rate') {
        return dispatch(CustomAccount.updateGic(name, null));
      }
    }

    if (
      name === 'gic_quantity' ||
      name === 'gic_rate' ||
      name === 'advisor_fee'
    ) {
      if ((name === 'gic_rate' || name === 'advisor_fee') && num > 100) {
        return this.setState({ [name]: 100 });
      }
      if (!negative) {
        const rate = num === '' ? '' : num;
        return name === 'advisor_fee'
          ? dispatch(CustomAccount.updateAdvisorFee(rate))
          : dispatch(CustomAccount.updateGic(name, rate));
      }
    } else if (name === 'gic_name' || name === 'gic_ticker') {
      return dispatch(CustomAccount.updateGic(name, value));
    }

    return false;
  };

  createAccountButtonDisabled = () =>
    !this.state.institution ||
    !this.state.name ||
    !this.state.name.trim() ||
    !this.state.currency ||
    this.state.errors.accountType ||
    this.state.errors.institution;

  closeModal = () =>
    this.setState({
      isOpen: false,
    });

  renderModal = (history, partnerName) => (
    <Modal basicTop open vb={notWealthica(partnerName)}>
      <Modal.Header>
        <Header icon="book" content="Name New Account" color="green" />
      </Modal.Header>
      <Modal.Content>
        <Field vb={notWealthica(partnerName)}>
          Institution:
          <input
            placeholder="(required)"
            name="institution"
            value={this.state.institution || ''}
            onChange={this.handleChange}
            vb={notWealthica(partnerName)}
          />
        </Field>
        <Field vb={notWealthica(partnerName)}>
          Account type:
          <input
            placeholder="(required)"
            name="name"
            value={this.state.name || ''}
            onChange={this.handleChange}
            vb={notWealthica(partnerName)}
          />
        </Field>
        <Field>
          Currency:
          <div style={{ width: '80%', float: 'right' }}>
            <StyledDropdown
              className={cn({ invalid: null })}
              placeholder="Currency"
              name="currency"
              selection
              options={[
                {
                  key: 'cad',
                  text: 'CAD',
                  value: 'CAD',
                  icon: <Flag name="ca" />,
                },
                {
                  key: 'usd',
                  text: 'USD',
                  value: 'USD',
                  icon: <Flag name="us" />,
                },
              ]}
              value={this.state.currency || ''}
              onChange={(e, data) => this.setState({ currency: data.value })}
              style={{ width: '95px' }}
            />
          </div>
        </Field>
      </Modal.Content>
      <Modal.Actions>
        <Button
          className={'left'}
          color={colors.red}
          icon="cancel"
          margin="0 0.5rem 0 0"
          onClick={() => history.push('/accounts/user')}
        >
          Cancel
        </Button>
        <Button
          className={cn(`left`, {
            loading: this.state.isLoading,
            disabled:
              !this.state.institution ||
              !this.state.name ||
              !this.state.currency,
          })}
          color={colors.green}
          icon="checkmark"
          onClick={this.createAccount}
        >
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );

  render() {
    const {
      history,
      match,
      customAcc,
      account,
      partnerName,
      french,
      user_region,
      toggle_region,
      dispatch,
    } = this.props;
    const { search } = customAcc;
    const { gic_ticker, gic_name, gic_quantity, gic_rate, advisorFee } =
      customAcc;
    this.state.advisor_fee = advisorFee;
    this.state.gic_rate = gic_rate;
    this.state.gic_quantity = gic_quantity;
    const { isOpen, conflictAccounts, gicError } = this.state;
    const gicFormat = /^GIC\d*:MKT$/;
    const hasGic = gic_ticker || gic_quantity || gic_rate;
    const filteredHoldings = Object.keys(customAcc.holdings).filter(
      (holding) => {
        if (gicFormat.test(holding)) {
          return false;
        }
        if (!customAcc.holdings[holding].security_detail) {
          return false;
        }
        return true;
      }
    );
    const isWealthica = partnerName === 'wealthica';
    const params = this.getSearchParams();

    const unmatchedHoldings = Object.keys(customAcc.holdings).filter(
      (holding) => !customAcc.holdings[holding].security_detail
    );

    if (match.params.id === 'new') {
      return this.renderModal(history, partnerName);
    }

    return (
      <Segment style={{ minHeight: '100%', textAlign: 'center' }}>
        <Header dividing size="large">
          {' '}
          {account.user_institution}{' '}
          <Flag name={account.currency === 'USD' ? 'us' : 'ca'} />
          <Header.Subheader>{account.label}</Header.Subheader>
        </Header>
        <Header size="medium" style={{ margin: 0 }}>
          {french ? 'Créer/Modifier un Compte' : 'Create/Edit an Account'}
        </Header>

        <Segment className="basic compact" style={{ textAlign: 'left' }}>
          <Table
            textAlign="center"
            style={{ width: '25rem', marginBottom: '1rem' }}
          >
            <Table.Body>
              <Table.Cell
                width={2}
                style={{
                  background: colors.hintGrey,
                  fontWeight: '700',
                }}
              >
                {french ? 'Montant' : 'Cash Amount'}&nbsp;
                <Popup
                  trigger={
                    <Icon
                      name="question circle outline"
                      style={{
                        fontSize: '15px',
                        verticalAlign: 'initial',
                        color: 'dimgrey',
                      }}
                    />
                  }
                  content={french ? 'Sans intérêt' : 'Non-interesting bearing.'}
                />
              </Table.Cell>
              <Table.Cell width={3} style={{ position: 'relative' }}>
                <div>
                  <CashAmount
                    value={customAcc.cash === undefined ? 0 : customAcc.cash}
                  />
                  <Flag
                    name={account.currency === 'USD' ? 'us' : 'ca'}
                    style={{ marginLeft: '0.3rem' }}
                  />
                </div>
              </Table.Cell>
            </Table.Body>
          </Table>
        </Segment>

        {/* <Header size="medium" style={{ margin: '0', marginBottom: '0.5rem' }}>
          {french ? 'Ajouter des titres' : 'Add Holdings'}{' '}
        </Header> */}
        <div
          style={{
            textAlign: 'left',
            marginTop: '2rem',
            maxWidth: '100%',
            marginBottom: '1rem',
          }}
        >
          <Header
            style={{ fontSize: '15.5px', marginBottom: '.3rem' }}
            content={
              french ? 'Ajouter/Modifier des Titres' : 'Add/Edit Holdings'
            }
          />
          <Note>
            {user_region === 'CA'
              ? account.currency === 'CAD'
                ? french
                  ? 'Actuellement, nous disposons de données sur les actions/ETF canadiens et américains, les fonds communs de placement et les fonds séparés canadiens, ainsi que les fonds HISA en CAD/USD.'
                  : 'Currently, we have data for Canadian and US stocks/ETFs, Canadian mutual and segregated funds, and CAD/USD HISA funds.'
                : french
                ? 'Pour les comptes en dollars US, nous n’avons de données que pour les actions et FNB inscrits aux États-Unis, les fonds communs américains et les titres inscrits au Canada mais libellés en dollars US.'
                : 'For USD accounts, we only have data for U.S.-listed stocks/ETFs, U.S. mutual funds, and Canadian-listed securities denominated in USD.'
              : 'Note: Currently we only have data for US-listed stocks and ETFs, and US mutual funds.'}
            {user_region === 'CA' && account.currency === 'CAD' ? (
              <Popup
                trigger={
                  <Icon
                    name="question circle outline"
                    style={{
                      fontSize: '15px',
                      verticalAlign: 'initial',
                      color: 'dimgrey',
                    }}
                  />
                }
                content={
                  french
                    ? "Les fonds HISA en CAD/USD sont inclus dans l'analyse en utilisant les taux historiques d'un fonds HISA CAD/USD représentatif d'une banque."
                    : 'CAD/USD HISA funds are included in the analysis using the historical rates of a representative bank-owned CAD/USD HISA fund.'
                }
              />
            ) : null}{' '}
            <br />
            {french
              ? "Vérifiez toujours le code du fonds ou le symbole boursier pour vous assurer d'avoir la bonne classe d'actions. Utilisez 'US' au lieu de 'U.S.'."
              : 'Always check the fund code or ticker symbol to ensure you have the correct share class. Use US instead of U.S..'}
          </Note>
          {account.provider !== 'uld' && filteredHoldings.length === 0 && (
            <Note style={{ marginBottom: '1rem' }}>
              <br />
              {french
                ? 'Si vous souhaitez allouer des fonds à des titres dans un nouveau compte, veuillez plutôt utiliser '
                : 'Note: If you are looking to allocate funds to securities in a new account, please use '}
              <Link to="/tools/new-account-setup">
                {french ? 'cet outil' : 'this tool'}
              </Link>
              {french ? '.' : ' instead.'}
            </Note>
          )}
        </div>

        <SearchTicker
          loading={customAcc.isFetching}
          results={getTickerSearchResult(search)}
          featureAction={CustomAccount}
          types={params.types}
          french={french}
          currency={params.region === 'US' ? 'USD' : ''}
        />
        {account.provider === 'uld' && !!filteredHoldings.length && (
          <Note2 style={{ marginTop: '2rem' }}>
            Prices and market values are automatically updated as of the
            previous close.
          </Note2>
        )}

        {/* <Note style={{ marginTop: '1rem' }}>
          {account.currency === 'CAD'
            ? french
              ? 'Pour les comptes en CAD, vous pouvez rechercher des actions canadiennes et américaines, des FNB canadiens et américains, ainsi que des fonds communs de placement et fonds distincts canadiens.'
              : 'For CAD accounts, you can search for Canadian and US stocks, Canadian and US ETFs, and Canadian mutual and segregated funds.'
            : french
            ? 'Pour les comptes en USD, vous ne pouvez rechercher que des actions et des FNB américains.'
            : 'For USD accounts, you can search only for US stocks and ETFS.'}
          <Popup
            trigger={
              <Icon
                name="question circle outline"
                style={{ fontSize: '15px', verticalAlign: 'initial' }}
              />
            }
            position="top center"
          >
            <Popup.Content>
              {french
                ? `Pour les fonds communs de placement, utilisez leur code de fonds (p. ex. : ${
                    account.currency === 'CAD' ? 'TDB339' : 'VTSMX'
                  }) si vous les avez, afin de vous assurer que vous avez la bonne catégorie d’actions. Si vous effectuez une recherche par nom, ne mettez pas de points (p. ex. : mettez "US" au lieu de "U.S.").`
                : `For mutual funds, use their fund code (e.g. 
              ${account.currency === 'CAD' ? 'TDB339' : 'VTSMX'}) if you have
              them to make sure you have the correct share class. If searching
              by name, do not include periods (e.g., put "US" instead of
              "U.S.")`}
            </Popup.Content>
          </Popup>
        </Note> */}
        {/* {notWealthica(partnerName) ? null : (
          <div>
            {account.provider !== 'uld' && (
              <Note style={{ marginBottom: '1rem' }}>
                Note: If you are looking to allocate funds to securities in a
                new account, please use
                <Link to="/tools/fund-allocator"> this tool </Link> instead.
              </Note>
            )}
          </div>
        )} */}

        {!!filteredHoldings.length && (
          <Segment className="basic compact">
            <Table textAlign="center" style={{ marginBottom: '2rem' }}>
              <Table.Header>
                <Table.Row style={{ position: 'relative' }}>
                  {account.provider !== 'uld' && (
                    <Popup
                      trigger={
                        <RemoveAll onClick={this.removeAll}>clear</RemoveAll>
                      }
                      wide
                      position="top center"
                      content="Clear all."
                    />
                  )}
                  <Table.HeaderCell>
                    {translateTableHeadings('Asset', french)}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {translateTableHeadings('Exchange', french)}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {translateTableHeadings('Class', french)}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {translateTableHeadings('Price', french)}
                  </Table.HeaderCell>
                  {isWealthica ? (
                    <Table.HeaderCell rowSpan="2">
                      Total Book Value
                      <br />
                      <span style={{ color: 'rgba(0,0,0,0.4)' }}>
                        (Optional)
                      </span>
                    </Table.HeaderCell>
                  ) : null}
                  <Table.HeaderCell>
                    {translateTableHeadings('Quantity', french)}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {Object.values(customAcc.holdings)
                  .reverse()
                  .map(
                    (holding, i) =>
                      !holding.gic_ticker &&
                      holding.security_detail && (
                        <StyledRow
                          negative={
                            !holding.security_detail.unadjusted_closing_price
                              .CAD
                          }
                          key={holding.security_detail.ticker || i}
                          style={{ height: 52 }}
                        >
                          <i
                            className="close"
                            onClick={() =>
                              this.remove(holding.security_detail.ticker)
                            }
                          >
                            +
                          </i>
                          <Table.Cell
                            style={{ position: 'relative' }}
                            width={5}
                          >
                            {holding.security_detail.ticker || 'N/A'}
                            <SecurityName>
                              {holding.security_detail.long_name || 'N/A'}
                            </SecurityName>
                            {!holding.security_detail.unadjusted_closing_price
                              .CAD && (
                              <Error>
                                <Popup
                                  trigger={
                                    <Icon
                                      style={{
                                        transform: 'translate(-20px, -4px)',
                                        position: 'absolute',
                                        display: 'block',
                                        marginTop: '0',
                                      }}
                                      name="exclamation circle"
                                    />
                                  }
                                  position="left center"
                                  content="Unfortunately, this security cannot be added as its price is $0"
                                />
                              </Error>
                            )}
                          </Table.Cell>
                          <Table.Cell>
                            {holding.security_detail.exchange_symbol || 'N/A'}
                          </Table.Cell>
                          <Table.Cell>
                            {translateAssetClass(
                              french,
                              holding.security_detail.global_asset_class
                            ) || 'N/A'}
                          </Table.Cell>
                          <Table.Cell>
                            ${this.getPrice(holding)}
                            <Flag
                              name={this.getPriceFlag(holding)}
                              style={{ marginLeft: '0.3rem' }}
                            />
                          </Table.Cell>
                          {isWealthica ? (
                            <Table.Cell style={{ position: 'relative' }}>
                              <Quantity
                                field="book_value"
                                isMarketValue
                                ticker={holding.security_detail.ticker}
                                value={holding.book_value}
                              />
                            </Table.Cell>
                          ) : null}
                          <Table.Cell
                            width={2}
                            style={{ position: 'relative' }}
                          >
                            {!!holding.security_detail.unadjusted_closing_price
                              .CAD ? (
                              <Quantity
                                field="quantity"
                                ticker={holding.security_detail.ticker}
                                value={holding.quantity}
                              />
                            ) : (
                              'N/A'
                            )}
                          </Table.Cell>
                        </StyledRow>
                      )
                  )}
              </Table.Body>
            </Table>
          </Segment>
        )}
        {!!unmatchedHoldings.length && (
          <Segment className="basic compact">
            <div
              style={{
                textAlign: 'left',
                maxWidth: '100%',
              }}
            >
              <Header
                style={{ fontSize: '15.5px', marginBottom: '.3rem' }}
                content="Unmatched Holdings"
              />
              <Note>
                The holdings below do not match any holdings in our database and
                will be excluded from the Wealthscope Scorecard. <br />
                If appropriate, you can add a replacement using the search bar
                above.
              </Note>
            </div>
            {account.provider === 'uld' && (
              <Note2 style={{ marginTop: '1em' }}>
                Unmatched holdings’ prices and book/market values are as
                uploaded.
              </Note2>
            )}
            <Table textAlign="center" structured>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">Asset</Table.HeaderCell>
                  <Table.HeaderCell>Price</Table.HeaderCell>
                  <Table.HeaderCell>Quantity</Table.HeaderCell>
                  <Table.HeaderCell>Book Value</Table.HeaderCell>
                  <Table.HeaderCell>Market Value</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {Object.values(customAcc.holdings).map(
                  (holding, i) =>
                    !holding.security_detail && (
                      <StyledRow
                        negative="true"
                        key={holding.ticker || i}
                        style={{ height: 52 }}
                      >
                        {holding.ticker ? (
                          <i
                            className="close"
                            onClick={() => this.remove(holding.ticker)}
                          >
                            +
                          </i>
                        ) : (
                          <Popup
                            trigger={
                              <Icon
                                className="info"
                                name="exclamation circle"
                              />
                            }
                            position="right center"
                            content="A ticker symbol or fund code has not been retrieved for this holding and it cannot be removed."
                          />
                        )}
                        <Table.Cell style={{ position: 'relative' }} width={5}>
                          {holding.ticker || 'N/A'}
                          <SecurityName>{holding.name || 'N/A'}</SecurityName>
                        </Table.Cell>
                        <Table.Cell style={{ position: 'relative' }}>
                          ${this.getPrice(holding, 'unmatched')}
                          <Flag
                            name={this.getFlag(customAcc.account.currency)}
                            style={{ marginLeft: '0.3rem' }}
                          />
                        </Table.Cell>
                        <Table.Cell style={{ position: 'relative' }}>
                          {formatNum(holding.quantity)}
                        </Table.Cell>
                        <Table.Cell style={{ position: 'relative' }}>
                          {holding.book_value === 0
                            ? 'N/A'
                            : formatNum(holding.book_value, '$')}
                        </Table.Cell>
                        <Table.Cell style={{ position: 'relative' }}>
                          {holding.market_value === 0
                            ? 'N/A'
                            : `${formatNum(holding.market_value, '$')}`}
                          <Flag
                            name={this.getFlag(customAcc.account.currency)}
                            style={{ marginLeft: '0.3rem' }}
                          />
                        </Table.Cell>
                      </StyledRow>
                    )
                )}
              </Table.Body>
            </Table>
          </Segment>
        )}

        <div style={{ padding: '0 1rem', marginBottom: '1.5rem' }}>
          <div style={{ textAlign: 'left' }}>
            <Header style={{ fontSize: '14.72px', margin: '0' }}>
              {user_region === 'CA'
                ? french
                  ? 'Ajouter CPG'
                  : 'Add GIC'
                : french
                ? 'Ajouter un CD'
                : 'Add CD'}
              <Popup
                trigger={
                  <Icon
                    name="question circle outline"
                    style={{
                      fontSize: '15px',
                      verticalAlign: 'initial',
                      color: 'dimgrey',
                    }}
                  />
                }
                position="top center"
                wide
              >
                <Popup.Content>
                  {user_region === 'CA'
                    ? french
                      ? 'Cette catégorie est destinée aux titres à revenu fixe, comme les certificats de placement garanti (CPG).'
                      : 'This category is for fixed interest securities such as Guaranteed Investment Certificates (GICs).'
                    : french
                    ? 'Cette catégorie est destinée aux titres à revenu fixe tels que les certificats de dépôt (CD) et les dépôts à terme (TD).'
                    : 'This category is for fixed interest securities such as Certificates of Deposits (CDs) and term deposits (TDs).'}
                </Popup.Content>
              </Popup>
            </Header>
            <Header.Subheader
              style={{ color: 'rgba(0,0,0,0.5)', fontSize: '0.9rem' }}
            >
              ({translateText('Optional', french)})
            </Header.Subheader>
          </div>
          <GicField>
            <label>{translateText('Value', french)}</label>
            <input
              className={cn({ invalid: null })}
              name="gic_quantity"
              type="number"
              placeholder="$"
              value={
                gic_quantity !== undefined && gic_quantity !== null
                  ? gic_quantity
                  : ''
              }
              onChange={this.handleGICOrAdvisorFeeChange}
            />
            {(gic_rate || gic_ticker) && !gic_quantity ? (
              <ErrorLabel>{translateText('Update value', french)}</ErrorLabel>
            ) : null}
          </GicField>
          <GicField>
            <label style={{ textAlign: 'left' }}>
              {translateText('Interest Rate', french)}
              <br />
              <span style={{ color: 'rgba(0,0,0,0.5)', fontSize: '1rem' }}>
                {french ? '(p. ex., 0.75%)' : '(e.g., 0.75%)'}
              </span>
            </label>
            <input
              className={cn({ invalid: null })}
              name="gic_rate"
              type="number"
              placeholder="%"
              value={
                gic_rate !== undefined && gic_rate !== null ? gic_rate : ''
              }
              onChange={this.handleGICOrAdvisorFeeChange}
            />
            {(gic_quantity || gic_ticker) && !gic_rate ? (
              <ErrorLabel>
                {translateText('Update interest rate', french)}
              </ErrorLabel>
            ) : null}
          </GicField>
          <GicField center>
            <label>
              {translateText('Ticker', french)}
              <Popup
                trigger={
                  <Icon
                    name="question circle outline"
                    style={{
                      fontSize: '15px',
                      verticalAlign: 'initial',
                      color: 'dimgrey',
                    }}
                  />
                }
                position="top center"
                wide
              >
                <Popup.Content>
                  {translateText(
                    'For display in the Portfolio Scorecard. Note that you can reuse this ticker in other accounts if the interest rate is the same.',
                    french
                  )}
                </Popup.Content>
              </Popup>
            </label>
            <input
              className={cn({ invalid: null })}
              name="gic_ticker"
              placeholder={user_region === 'CA' ? 'e.g. GIC 1' : 'e.g. CD 1'}
              value={gic_ticker || ''}
              onChange={this.handleGICOrAdvisorFeeChange}
            />
            {(gic_quantity || gic_rate) && !gic_ticker ? (
              <ErrorLabel>{translateText('Update ticker', french)}</ErrorLabel>
            ) : null}
          </GicField>
          <GicField center>
            <label>
              {translateText('Name', french)}
              <Popup
                trigger={
                  <Icon
                    name="question circle outline"
                    style={{
                      fontSize: '15px',
                      verticalAlign: 'initial',
                      color: 'dimgrey',
                    }}
                  />
                }
                position="top center"
                wide
              >
                <Popup.Content>
                  {translateText(
                    'For display in the Portfolio Scorecard. Note that you can reuse this ticker in other accounts if the interest rate is the same.',
                    french
                  )}
                </Popup.Content>
              </Popup>
            </label>
            <input
              className={cn({ invalid: null })}
              name="gic_name"
              placeholder={`(${translateText('Optional', french)})`}
              value={gic_name || ''}
              onChange={this.handleGICOrAdvisorFeeChange}
            />
          </GicField>
        </div>
        {gicError === 'Ticker' && (
          <Message visible error style={{ margin: '0 auto', width: '400px' }}>
            <Icon
              name="exclamation circle"
              style={{ fontSize: '16px', transform: 'translateY(1px)' }}
            />
            {french
              ? `Ce symbole a déjà été utilisé dans un compte ${
                  account.currency === 'USD' ? 'CAD' : 'USD'
                }. Veuillez choisir un nouveau symbole. `
              : `This ticker has already been used in a ${
                  account.currency === 'USD' ? 'CAD' : 'USD'
                } account. Please enter a
            different ticker.`}
          </Message>
        )}
        {gicError === 'Unique' && (
          <Message visible error style={{ margin: '0 auto', width: '240px' }}>
            <Icon
              name="exclamation circle"
              style={{ fontSize: '16px', transform: 'translateY(1px)' }}
            />
            {translateText('The limit is 10 GICs/HISAs.', french)}
          </Message>
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            margin: 'auto',
            width: 'fit-content',
            paddingLeft: account.provider === 'uld' ? '6rem' : 0,
          }}
        >
          <Button
            style={{
              marginTop: account.provider === 'uld' ? '2rem' : 0,
              marginRight: account.provider === 'uld' ? '2rem' : 0,
            }}
            className={cn('left centered grey-focus2', {
              disabled: this.isDisabled() || gicError,
              loading: customAcc.isFetching,
            })}
            color={colors.green}
            icon="line chart"
            onClick={() => {
              if (Object.keys(customAcc.holdings).length || hasGic) {
                this.saveBulk();
              } else {
                this.saveOnlyCash();
              }
              const key = `${
                account.id ? account.id : account.user_institution
              }::${true}`;
              const keyOverview = `Overview; All Accounts::${true}`;
              dispatch(AiToolset.removeAnalyzeScorecard(key));
              dispatch(AiToolset.removeAnalyzeScorecard(keyOverview));
            }}
          >
            {translateText('Save', french)}
          </Button>
          {account.provider === 'uld' && (
            <Note2 style={{ width: '32rem', alignContent: 'end' }}>
              Values in the saved account may differ from your statement because
              they are automatically updated as of the previous close.
            </Note2>
          )}
        </div>

        <ConfirmModal
          account={account}
          accountList={this.props.accountList}
          close={this.closeModal}
          conflictAccounts={conflictAccounts}
          open={isOpen === 'confirm'}
          setResolveGicConflict={this.setResolveGicConflict}
        />
      </Segment>
    );
  }
}

BuildCustomAccount.propTypes = {
  dispatch: PropTypes.func,
  customAcc: PropTypes.object,
  account: PropTypes.object,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  partnerName: PropTypes.string,
  accountList: PropTypes.array,
  french: PropTypes.bool,
  user_region: PropTypes.string,
  toggle_region: PropTypes.string,
};

BuildCustomAccount.defaultProps = {
  dispatch: () => null,
  customAcc: {},
  account: {},
  partnerName: '',
  accountList: [],
  french: false,
  user_region: 'CA',
  toggle_region: 'CA',
};

const SecurityName = styled.div`
  font-size: 0.9rem;
  line-height: 1rem;
  color: ${(props) =>
    props.negative ? 'rgba(159,58,56, 0.6)' : 'rgba(0,0,0,0.5)'};
`;

const StyledRow = styled(({ className, children, ...rest }) => (
  <Table.Row className={className} {...rest}>
    {children}
  </Table.Row>
))`
  position: relative;

  .close {
    position: absolute;
    display: block;
    margin: -10px;
    margin-top: 20px;
    z-index: 100;
    transform: rotate(45deg);
    text-align: center;
    font-size: 1.7rem;
    font-style: normal;
    border-radius: 18px;
    height: 20px;
    width: 20px;
    line-height: 17px;
    padding: 0 1px;
    background: white;
    border: 1px solid #e4e5e5;
    color: black;
    cursor: pointer;
    transition: background 0.1s ease, border 0.1s ease;

    &:hover {
      background: #fff6f6;
      border: 1px solid #db2828;
    }
  }
`;

const RemoveAll = styled.div`
  position: absolute;
  top: 50%;
  left: -25px;
  transform: translateY(-50%);
  background: white;
  width: 50px;
  font-size: 0.9rem;
  border-radius: 10px;
  line-height: 20px;
  text-align: center;
  border: 1px solid #dededf;
  cursor: pointer;
  transition: border 0.2s ease;

  &:hover {
    border: 1px solid #db2828;
    background: #fff6f6;
  }
`;

const Error = styled.div`
  font-size: 1.7rem;
  position: absolute;
  top: 50%;
  left: -2.3rem;
  margin: -0.8rem auto;
  color: ${colors.red};
`;

const Field = styled.div`
  padding: 1rem 0 0 0;
  font-size: 1.14rem;
  line-height: 1.3em;
  border-bottom: 1px solid grey;
  padding: 0 0 1rem 0;
  &:last-child {
    padding: 1rem 0 0 0;
    border-bottom: unset;
  }

  &:nth-child(2) {
    padding: 1rem 0;
  }

  input {
    float: right;
    border: 0;
    background: transparent;
    width: 80%;
    color: rgba(0, 0, 0, 0.6);

    &:focus {
      outline: 0;
    }
  }
`;

const Note = styled.div`
  font-size: 1.1rem;
  color: rgba(0, 0, 0, 0.5);
  margin: 0 auto;
`;

const Note2 = styled.p`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${colors.navyBlue};
  margin: 0 0 1rem 0;
  max-width: 100%;
`;

const StyledDropdown = styled(({ children, className, ...rest }) => (
  <Dropdown className={className} {...rest}>
    {children}
  </Dropdown>
))`
  height: 25px !important;
  min-height: unset !important;
  padding: 0.3rem !important;
  min-width: unset !important;
  &.invalid {
    border: 1px solid ${colors.red} !important;
    background: rgb(255, 240, 240) !important;
  }
  i {
    padding: 0.5rem !important;
  }
`;

const GicField = styled.fieldset`
  margin: 0.5rem 0;
  border: 0;
  padding: 0;
  position: relative;
  width: 100%;
  min-height: 32px;
  label {
    display: block;
    float: left;
  }
  input {
    position: absolute;
    left: calc(50% - 47px);
    padding: 0.4rem;
    border-radius: 3px;
    border: 1px solid rgba(34, 36, 38, 0.15);
    transition: all 200ms ease;
    color: rgba(0, 0, 0, 0.8);
    width: 100%;
    max-width: 93px;
    font-size: 0.9rem;
    text-align: right;
    outline: none;
    &:focus,
    &:active {
      outline: none;
      border: 1px solid rgb(132, 183, 217);
      &::placeholder {
        color: rgba(0, 0, 0, 0.5);
      }
    }
    &::placeholder {
      color: rgba(0, 0, 0, 0.3);
      text-align: ${(props) => (props.center ? 'center' : 'right')};
    }
    &.invalid {
      border: 1px solid ${colors.red};
      background: rgb(255, 240, 240);
    }
  }
`;

const ErrorLabel = styled.div`
  position: absolute;
  white-space: nowrap;
  background-color: #fff;
  color: #db2828;
  border: 1px solid #db2828;
  font-size: 0.8rem;
  line-height: 1;
  padding: 11px 13px;
  font-weight: 700;
  z-index: 1;
  border-radius: 4px;
  left: calc(50% + 58px);
  text-transform: initial;

  &:not(.basic):before {
    content: '';
    position: absolute;
    z-index: 2;
    width: 8px;
    height: 8px;
    transform: translate(3%, 0) rotate(45deg);
    background: inherit;
    left: -5px;
    margin-top: -4px;
    top: 50%;
    border-width: 0 0 1px 1px;
    border-style: solid;
  }
`;
